/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module UpdateModule
 */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import './progress-note.component.less';
import * as l10n from './progress-note.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 * Progress note for Wizard Page.
 * @author Dhanashree Tilak, Deepak Chaudhary
 */
@Component({
    selector: 'progress-note',
    templateUrl: './progress-note.component.html',
})
export class ProgressNoteComponent {
    /**
     * The object containing the localize strings for this component.
     */
    public readonly l10nKeys = l10nKeys;

    public constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
